const createScriptElement = (scriptSrc, scriptId) => {
  const taggingScript = document.createElement("script");
  taggingScript.src = scriptSrc;
  taggingScript.async = true;
  taggingScript.id = scriptId;

  return taggingScript;
};

export default createScriptElement;
